module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image5c"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "328",
      "src": "images/7.jpg",
      "width": "300"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Debt stops dreams.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("A typical credit card purchase ends up costing 112 percent more than if you’d used cash. A $1,000 charge on an average credit card will take almost twenty-two years to pay and will cost more than $2,300 in interest if you make only minimum payments."), _c('sup')]), _c('a', {
    attrs: {
      "id": "ch0fn1"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#ich0fn1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")]), _vm._v(" So that $1,000 purchase really costs you $3,300.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But what if instead of making the credit card companies rich, you invested in yourself? If you save $218 per month for twenty-five years, you would retire with $1,354,930.00!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }), _vm._v(" "), _c('div', {
    staticClass: "sidebar"
  }, [_c('p', {
    staticClass: "h4"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("How to use a credit card wisely")])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("1. Try to pay off the balance every month.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("2. Only use the credit card for:")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanginga"
  }, [_vm._v("• business expenses for which you will be reimbursed. (Remember to pay the credit card charges when you receive reimbursement.)")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanginga"
  }, [_vm._v("• renting a car. (Most car rental companies accept only major credit cards for payment.)")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanginga"
  }, [_vm._v("• medical emergencies.")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanginga"
  }, [_vm._v("• auto repairs that affect your ability to drive the car.")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanginga"
  }, [_vm._v("• replacing broken major appliances if they are absolutely necessary (like water heater, stove, or refrigerator).")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("3. DO NOT use your credit card to purchase:")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanginga"
  }, [_vm._v("• clothes.")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanginga"
  }, [_vm._v("• food, whether at restaurants or the grocery store.")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanginga"
  }, [_vm._v("• music.")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanginga"
  }, [_vm._v("• books.")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanginga"
  }, [_vm._v("• entertainment.")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanginga"
  }, [_vm._v("• haircuts.")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanginga"
  }, [_vm._v("• games—computer, video, or otherwise.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindentl1"
  }, [_vm._v("Purchase these items with cash as you can afford them out of your income.")])])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-722da8a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch04.vue
// module id = 96
// module chunks = 0